import { useEffect, useState } from "react";
import { X } from "lucide-react";
import axios, { API } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";

const CATEGORIES = ["Semua", "Manasik", "Keberangkatan", "Kegiatan Jamaah", "Kajian", "Tanah Suci", "Kegiatan Sosial"];

export default function Galeri() {
  const [albums, setAlbums] = useState(null);
  const [category, setCategory] = useState("Semua");
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    const params = category !== "Semua" ? { category } : {};
    axios.get(`${API}/public/gallery/albums`, { params }).then(({ data }) => setAlbums(data)).catch(() => setAlbums([]));
  }, [category]);

  const allItems = (albums || []).flatMap((a) => a.items.map((i) => ({ ...i, albumTitle: a.title })));

  return (
    <div data-testid="galeri-page">
      <section className="bg-gradient-to-br from-[#084C3A] to-[#0B4F71] px-4 py-16 text-center sm:px-6">
        <h1 className="font-heading text-3xl font-bold text-white sm:text-4xl">Galeri Kegiatan</h1>
        <p className="mt-3 text-white/80">Dokumentasi kegiatan pembinaan dan perjalanan ibadah jamaah kami.</p>
      </section>

      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <Tabs value={category} onValueChange={setCategory}>
          <TabsList data-testid="gallery-category-tabs" className="flex-wrap justify-start gap-1 rounded-full bg-[#F5F9F7] h-auto p-1.5">
            {CATEGORIES.map((c) => (
              <TabsTrigger key={c} value={c} data-testid={`gallery-tab-${c.toLowerCase().replace(/\s+/g, "-")}`} className="rounded-full">{c}</TabsTrigger>
            ))}
          </TabsList>
        </Tabs>

        {albums === null ? (
          <LoadingScreen />
        ) : allItems.length === 0 ? (
          <div className="mt-10"><EmptyState title="Belum ada foto" description="Galeri untuk kategori ini akan segera tersedia." /></div>
        ) : (
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {allItems.map((item, idx) => (
              <button
                key={item.id || idx}
                data-testid={`gallery-item-${idx}`}
                onClick={() => setLightbox(item)}
                className="group relative aspect-square overflow-hidden rounded-2xl"
              >
                <img src={item.image_url} alt={item.caption || item.albumTitle} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
              </button>
            ))}
          </div>
        )}
      </div>

      {lightbox && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4" data-testid="gallery-lightbox" onClick={() => setLightbox(null)}>
          <button className="absolute right-6 top-6 text-white" data-testid="gallery-lightbox-close" onClick={() => setLightbox(null)}>
            <X className="h-7 w-7" />
          </button>
          <img src={lightbox.image_url} alt={lightbox.caption} className="max-h-[85vh] max-w-[90vw] rounded-xl object-contain" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
}
